
export async function loadPaymentGateway(gatewayName) {
   
    if (gatewayName !== null && gatewayName.length > 0) {
        switch (gatewayName.toLowerCase()) {
            case 'braintree':{
               
               try{//Dynamic Import 
                const[braintreeCore,braintreeDropin] = await Promise.all([
                    import(/* webpackChunkName: "braintree-core" */'braintree-web'),
                    import(/* webpackChunkName: "braintree-dropin" */'braintree-web-drop-in')    
                ]); 
            
                const braintree = braintreeCore.default;
                const dropin = braintreeDropin.default; 

                //assemble the plugin 
                braintree.dropin = dropin ; 
                return braintree; 
               // return null; 
                }
            catch(error){
                console.error("Error loading Braintree modules: ", error ); 
                throw error; 
            } 
            }
            default : 
            throw new Error('Unsupported Gateway: '+{gatewayName}); 
        }
    }
   
}
